import RegGradeDirMedSer from '@/modules/JobListing/components/DoctorStories/assets/RegGradeDirMedSer.svg';
import RegGradeRegistrar from '@/modules/JobListing/components/DoctorStories/assets/RegGradeRegistrar.png';
import RegGradeUniversal from '@/modules/JobListing/components/DoctorStories/assets/RegGradeUniversal.svg';
import { DoctorGrade } from '@/modules/JobListing/utils/JobListingTypes';
import Image from 'next/image';

import styles from './DoctorAvatar.module.scss';

export interface DoctorAvatarProps {
  grade?: DoctorGrade;
  // A real CMS-supplied photo takes priority over the illustrated grade avatars, which exist
  // only as a fallback for the hand-authored static stories that have no photo.
  avatarImageUrl?: string;
}

export const DoctorAvatar = ({ grade = 'Universal', avatarImageUrl }: DoctorAvatarProps) => {
  if (avatarImageUrl) {
    return (
      <div className={styles.avatar}>
        <Image src={avatarImageUrl} alt="" width={48} height={48} />
      </div>
    );
  }

  if (grade === 'Registrar') {
    return (
      <div className={styles.avatar}>
        <Image src={RegGradeRegistrar} alt="" width={48} height={48} />
      </div>
    );
  }

  return (
    <div className={styles.avatar}>
      {grade === 'Universal' ? <RegGradeUniversal /> : <RegGradeDirMedSer />}
    </div>
  );
};

export default DoctorAvatar;
